import React from "react";
import { RelatedLinks } from "../components/site/RelatedLinks";
import { SeoExtras } from "../components/site/SeoExtras";
import { PageHero, FeatureCard } from "../components/site/Common";
import { IMG } from "../mock";
import { useReveal } from "../lib/lang";

const VALUES = [
  ["compass", "Local knowledge", "We live here. We know the roads, the shortcuts and the best time to travel."],
  ["shield", "Professional drivers", "Licensed, courteous and English-speaking — in smart, spotless vehicles."],
  ["car", "Comfortable vehicles", "A modern, well-kept fleet maintained to the highest standard."],
  ["clock", "Reliable service", "On time, every time — with flight monitoring built in."],
  ["heart", "Personal attention", "Real people who care about making your stay effortless."],
];

const About = () => {
  useReveal();
  return (
    <div data-testid="about-page">
      <PageHero image={IMG.oldTown} eyebrow="Our story" title="Welcome to Aloha Corfu Transfers"
        sub="A local Corfu company dedicated to making every journey around the island comfortable, reliable and stress-free." />
      <section className="py-12 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-[1fr_1.4fr] gap-8 lg:gap-14">
          <div className="reveal">
            <p className="eyebrow">Who we are</p>
            <p className="font-serif-d text-[21px] sm:text-[28px] leading-snug text-[#183C35] mt-3 sm:mt-4">We are a local Corfu transfer company dedicated to making every journey around the island comfortable, reliable and stress-free.</p>
            <p className="mt-6 text-[17px] leading-relaxed text-[#202522]/75">From the moment you land at Corfu Airport to the moment you arrive at your villa, hotel or destination, our goal is simple: make getting around Corfu effortless.</p>
          </div>
          <div className="grid sm:grid-cols-2 gap-3 sm:gap-5">
            {VALUES.map(([i, t, d]) => <FeatureCard key={t} icon={i} title={t} text={d} />)}
          </div>
        </div>
      </section>
      <SeoExtras path="/about" page="about" />
      <RelatedLinks current="/about" />
    </div>
  );
};

export default About;
